// Abyss (Neptune): stars in the bottom third of the sky are worth more at
// the base.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentDef } from '../types';

export const abyss: AlignmentDef = {
  id: 'abyss',
  planet: 'neptune',
  name: 'Abyss',
  text: () => `Stars in the bottom third of the sky have +${N.abyssAdd} base value.`,
  baseAdd: (star, _c, ctx) => (star.node.y >= ctx.sky.height * N.abyssFrom ? N.abyssAdd : 0),
};
